import { Option } from '@indigo-ag/component-module';

const dropDown = {
  addEmptyDefaultValue(options: Option[]) {
    return [{ label: '', value: undefined }, ...options] as Option[];
  }
};

export { dropDown };
